import {
  createFileRoute,
} from '@tanstack/react-router'

import {
  PayeeApprovalPage,
} from '@/features/payee/pages/payee-approval-page'

export const Route =
  createFileRoute(
    '/_authenticated/payee/pending-approval_/$payeeId',
  )({
    component:
      PayeeApprovalPage,
  })